import { T } from "@utils/enums";
import { useEffect, useState } from "react";
interface ITestWidgetsView {
  widgetUrl?: string;
}
export default function TestWidgetsView( {widgetUrl = '/StatsConsole/'}: ITestWidgetsView ) {
  const [iframeHeight, setIframeHeight] = useState('auto');
  const [iframeWidth, setIframeWidth] = useState('auto');

  const [baseUrl, setBaseUrl] = useState('');
  const [eventId, setEventId] = useState(0);
  const [maxEventId, setMaxEventId] = useState(8);
  const [theme, setTheme] = useState(T.LIGHT);
  const [state, setState] = useState("minimized")
  const [language, setLanguage] = useState('en_GB');
  const [languageList, setLanguageList] = useState(['en_GB', 'da_DK', 'fr_FR', 'et_EE', 'ro_RO']);
  const [languageIndex, setLanguageIndex] = useState(0);
  const [input1, setInput1] = useState(`${baseUrl}${widgetUrl}${language}/${state}?theme=light&fixtures=true&eventId=${eventId}`);


  const [iframBorderIsVisible, setIframeBorderIsVisible] = useState(false);

  const onChangeInput1 = (event: any) => {
    let  newInput = event?.target?.value?.includes('http') ? event.target.value : `${baseUrl}${event.target.value}`;
    setInput1(newInput);
  }

  const onChangeTheme = () => {
    setTheme(theme === T.DARK ? T.LIGHT : T.DARK);
  }

  const onChangeEventId = () => {
    setEventId(eventId + 1);
    if (eventId === maxEventId) {
      setEventId(0);
    }
  }

  const onChangeLanguage = () => {
    setLanguageIndex(languageIndex + 1);
    if (languageIndex === languageList.length -1) {
      setLanguageIndex(0);
    }
  }

  const onOpenInNewTab = () => {
    window.open(input1, '_blank');
  }

  useEffect(() => {
    const handleResizeMessage = (event: any) => {

      if (event.data && event.data?.type === 'suzu_stats_console_iframe') {
        setIframeHeight(`${event.data?.height}`);
        // setIframeWidth(`${event.data?.width}`);
      }
    };

    window.addEventListener('message', handleResizeMessage);

    return () => {
      window.removeEventListener('message', handleResizeMessage);
    };
  }, []);

  useEffect(() => {
    const fullUrl = window.location.href;
    const url = new URL(fullUrl);
    const port = url.port ? `:${url.port}` : '';
    const baseUrl = `${url.protocol}//${url.hostname}${port}`;
    setBaseUrl(baseUrl);
  }, [window.location.href]);

  useEffect(() => {
    setLanguage(languageList[languageIndex]);
  }, [languageIndex]);


  useEffect(() => {
    setInput1(`${baseUrl}${widgetUrl}${language}/${state}?theme=${theme}&fixtures=true&eventId=${eventId}`);
  }, [eventId, theme, baseUrl, widgetUrl, state, language]);

  return (
    <div className={`flex-col text-white flex items-start min-h-screen w-[100%]'`}>
      <div className="flex h-full ">
      <div className='flex flex-col items-center  gap-2 p-10 w-full h-full'>
        <div className="flex gap-2">
          <input 
          type="text"
          className="mb-10 w-[50%] sm:w-[500px] h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]"
          value={input1}
          onChange={onChangeInput1}
          />
          <button className=" h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]" onClick={onOpenInNewTab}>Open in new tab</button>
        </div>
          <iframe
          
          // className={`transition-all duration-1000 ease-in-out max-w-[351px] min-w-[351px]
          className={`transition-all duration-1000 ease-in-out
            ${iframBorderIsVisible ? 'border-[2px] border-[#4f8f36]' : 'border-none'}`}
          src={input1}
          style={{ width: '100%', height: iframeHeight, minHeight: iframeHeight, minWidth: iframeWidth, maxWidth: iframeWidth}}
        />
        <div className="mt-1 gap-[10px] w-full flex items-center justify-center">
          <button className="w-[100px] h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]"
            onClick={() => setState("minimized")}>minimized</button>
          <button className="w-[100px] h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]"
            onClick={() => setState("standard")}>standard</button>
          <button className="w-[100px] h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]"
            onClick={() => setState("expanded")}>expanded</button>
        </div>
        <div className="mt-1 gap-[10px] w-full flex items-center justify-center">
          <button className="w-auto h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]"
            onClick={() => setIframeBorderIsVisible(!iframBorderIsVisible)}>show iframe border</button>
          <button className="w-[100px] h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]"
            onClick={onChangeTheme}>change theme</button>
        </div>
        <div className="mt-1 gap-[10px] w-full flex items-center justify-center">
          <button className="w-auto h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]"
            onClick={onChangeEventId}>change eventId</button>
        </div>
        <div className="mt-1 gap-[10px] w-full flex items-center justify-center">
          <button className="w-auto h-[30px] p-2 rounded-[5px] bg-[#333333] text-[#999999] text-[12px] leading-[16px] font-[500]"
            onClick={onChangeLanguage}>change language</button>
        </div>
      </div>
      </div>
    </div>
  );
}